  @for (contract of waitingContracts$ | async; track contract.guid) {
    <ion-item lines="none"
      button="true"
      (click)="onContract(contract)">
      <div>
        {{ contract.contractorName }}<br />
        <ion-note>{{ contract.partner.name }}</ion-note>
      </div>
      <ion-chip slot="end">
        {{ 'offer.notSigned' | translate }}
      </ion-chip>
      <span slot="end">
        {{ contract.date | timestamp:'d.M.yyyy' }}
      </span>
    </ion-item>
  }
  @for (contract of signedContracts$ | async; track contract.guid) {
    <ion-item lines="none"
      button="true"
      (click)="onContract(contract)">
      <div>
        {{ contract.contractorName }}<br />
        <ion-note>{{ contract.partner.name }}</ion-note>
      </div>
      <ion-chip color="success"
        slot="end">
        {{ 'offer.signed' | translate }}
      </ion-chip>
      <span slot="end">
        {{ contract.date | timestamp:'d.M.yyyy' }}
      </span>
    </ion-item>
  }